import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import UIIcon from "common/blocks/UIIcon";

import styles from "./NameTestDriveSummary.module.scss";

const cx = classNames.bind(styles);

export type NameTestDriveSummaryProps = {
    make: string;
    model: string;
    trim: string;
    variant: string;
    buttonText?: string;
    buttonLink: string;
    isComingSoon?: boolean;
};

const NameTestDriveSummary = ({
    make,
    model,
    trim,
    variant,
    buttonText,
    buttonLink,
    isComingSoon = false,
}: NameTestDriveSummaryProps) => {
    return (
        <div id="name-test-drive" className={cx("nameTestDrive")}>
            <div className={cx("name")}>
                <h1 className={cx("nameTitle")}>
                    {make} {model}
                </h1>
                <span className={cx("nameVariant")}>{trim}</span>
            </div>
            {!!buttonText && !!buttonLink && !isComingSoon && (
                <div className={cx("testDrive")}>
                    <Button
                        type="button"
                        theme="selection"
                        size="medium"
                        className={cx("testDriveButton")}
                        href={buttonLink}
                        target="_blank"
                        ariaLabel={buttonText}
                        rel="nofollow"
                    >
                        <UIIcon icon="CarFront" className={cx("testDriveButtonIcon")} />
                        {buttonText}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default NameTestDriveSummary;
